module.exports = __webpack_public_path__ + "static/ettin-461a07c6da71a9070f60731dfea51db6.jpg";